import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from '@codex/basics';
import { hasNav } from '../../../helpers';

const SubmenuList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 10px;
  border-left: 2px solid  ${({ theme }) => theme.colors.message.hover};
  border-bottom-right-radius: ${({ theme }) => (theme.name === 'brightworld' ? '10px' : '5px')};
  box-sizing: content-box;
  min-width: 220px;
  background-color: ${({ theme }) => theme.colors.shades[7]};
`;

const SubmenuItem = styled.li`
  padding: 6px 10px;
`;

const SubmenuLink = styled(Link)`
  white-space: nowrap;
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.link.default};
`;

const TypeList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const TypeListItem = styled.li`
  display: inline-flex;
  border-right: 1px solid ${({ theme }) => theme.colors.shades[3]};
  padding-right: 5px;
  margin: 5px 5px 0 0;

  &:last-child {
    border-right: 0;
  }
`;

const TypeListLink = styled(Link)`
  display: block;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.header.nav.link.text};
  font-size: 13px;
`;

const Submenu = props => (
  <SubmenuList>
    {
      props.nav.map((submenuItem, i) => (
        <SubmenuItem key={i}>
          {
            submenuItem.label && (
              <SubmenuLink href={submenuItem.link}>{submenuItem.label}</SubmenuLink>
            )
          }
          {
            hasNav(submenuItem) && (
              <TypeList>
                {
                  submenuItem.nav.map((linkItem, j) => (
                    <TypeListItem key={j}>
                      <TypeListLink href={linkItem.link}>
                        {linkItem.label}
                      </TypeListLink>
                    </TypeListItem>
                  ))
                }
              </TypeList>
            )
          }
        </SubmenuItem>
      ))
    }
  </SubmenuList>
);

Submenu.propTypes = {
  nav: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
      nav: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          link: PropTypes.string,
          nav: PropTypes.arrayOf(
            PropTypes.shape({
              label: PropTypes.string,
              link: PropTypes.string
            })
          )
        })
      )
    })
  ).isRequired
};

export default Submenu;
